import NativeCarousel from '~/components/Molecules/NativeCarousel';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default {
  __name: 'MenuTopbarMobileGraphql',
  props: {
    menuItems: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers;
    var consolidatedMenuItems = computed(function () {
      var _props$menuItems, _props$menuItems$item;
      return (_props$menuItems = props.menuItems) === null || _props$menuItems === void 0 ? void 0 : (_props$menuItems$item = _props$menuItems.itemForMobileMenuShortcutsSliderCollection) === null || _props$menuItems$item === void 0 ? void 0 : _props$menuItems$item.items;
    });

    /**
     * Gets the item link.
     *
     * @param      {Object}  item    The item
     * @return     {String}  The item link.
     */
    function getItemLink(item) {
      var _ref, _item$url;
      return (_ref = (_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : item.externalLinkUrl) !== null && _ref !== void 0 ? _ref : '';
    }
    return {
      __sfc: true,
      $trackers: $trackers,
      props: props,
      consolidatedMenuItems: consolidatedMenuItems,
      getItemLink: getItemLink,
      NativeCarousel: NativeCarousel,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
};